var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 8H24C15.1634 8 8 15.1634 8 24V104C8 112.837 15.1634 120 24 120H104C112.837 120 120 112.837 120 104V24C120 15.1634 112.837 8 104 8Z",
    fill: "#904EE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3859 62.0528L87.37 62.0208C87.738 61.4208 88.002 60.7568 88.002 59.9968C88.002 57.7888 86.21 55.9968 84.002 55.9968H64.002V35.9968C64.002 33.7888 62.21 31.9968 60.002 31.9968C58.626 31.9968 57.482 32.7328 56.762 33.7808C56.538 34.1088 56.354 34.4448 56.234 34.8208L40.65 65.8928L40.666 65.9168C40.282 66.5328 40.002 67.2208 40.002 67.9968C40.002 70.2128 41.794 71.9968 44.002 71.9968H64.002V91.9968C64.002 94.2128 65.794 95.9968 68.002 95.9968C69.434 95.9968 70.634 95.2048 71.346 94.0688L71.37 94.0768L71.474 93.8688C71.562 93.7008 71.658 93.5488 71.722 93.3728L87.3859 62.0528Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpic);
export default __webpack_public_path__ + "static/media/Epic.bfccf62c5a8459e729f181f6709fc626.svg";
export { ForwardRef as ReactComponent };